import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../modules/common/service/auth/auth.service';


@Component({
    selector: 'app-login',
    templateUrl: './app.login.component.html',
    styleUrls: ['../auth.component.scss'],
    standalone: false
})
export class AppLoginComponent implements OnInit {
    constructor(private readonly authService: AuthService) {}

    ngOnInit(): void {
        this.authService.logoutRedirect();
    }
}
